import { inject } from "vue";
const APP_SETTINGS_REGISTRATION_KEY = Symbol.for("NcAppSettingsDialog:registration");
const APP_SETTINGS_LEGACY_DESIGN_KEY = Symbol.for("NcAppSettingsDialog:legacy");
function useAppSettingsDialog() {
  return inject(APP_SETTINGS_REGISTRATION_KEY);
}
export {
  APP_SETTINGS_LEGACY_DESIGN_KEY as A,
  APP_SETTINGS_REGISTRATION_KEY as a,
  useAppSettingsDialog as u
};
//# sourceMappingURL=useAppSettingsDialog-DbtEkXa4.mjs.map
